<mat-drawer-container class="main-container" style="background-color: white;" autosize>
    <mat-drawer #drawer class="sidenav-drawer" class="drawer-style" mode="side" opened>
        <div class="mt-40">
        </div>
    </mat-drawer>
    <mat-drawer-content class="overflow-hidden">
        <div class="sidenav-content">
            
          <div class="row col-12 m-0 centerAlign">
            <div class="col-5 mt-5">
              <div class="entityDet-title">
                <form class="w-100" #resetPasswordForm="ngForm" (ngSubmit)="resetPassword(resetPasswordForm.value)">
              
                  <h2 class="justify-content-center d-flex w-100 fontweighthead">{{resetHeading}}</h2>
              
                  <div class="col-md-12  inherit-display">
                    <div class="row col-md-12 inherit-display">
                      <label class="fontweightlabel" *ngIf="resetPasswordForm.value.password != null && resetPasswordForm.value.password != ''">Password</label>
                    </div>
                    
                    <div [ngClass]="(PasswordControl.touched==true&&PasswordControl.invalid==true)?'single-column  error-column': 'single-column'">                    
                      <label class="error-label mat-body-1" *ngIf="PasswordControl.touched==true&&PasswordControl.invalid==true">Password is required</label>
                      <input type="password" class="input-text-labeldesign" aria-label="Password" autocomplete="off" placeholder="Password" #PasswordControl="ngModel" [(ngModel)]="resetPasswordForm.value.password" name="password" required tabindex="2" />
                    </div>
                  </div>
                  <div class="col-md-12  inherit-display">
                    <div class="row col-md-12 inherit-display">
                      <label class="fontweightlabel" *ngIf="resetPasswordForm.value.confirm != null && resetPasswordForm.value.confirm != ''">Confirm Password</label>
                    </div>
                    
                    <div [ngClass]="(ConfirmPasswordControl.touched==true&&ConfirmPasswordControl.invalid==true)?'single-column  error-column': 'single-column'">                    
                      <label class="error-label mat-body-1" *ngIf="ConfirmPasswordControl.touched==true&&ConfirmPasswordControl.invalid==true">Confirmation is required</label>
                      <input type="password" class="input-text-labeldesign" aria-label="Password" autocomplete="off" placeholder="Confirm Password" #ConfirmPasswordControl="ngModel" [(ngModel)]="resetPasswordForm.value.confirm" name="confirmpassword" required tabindex="2" />
                    </div>
                  </div>
              
              
                  <div class="button-row mt-4" >
                    <button class="col-md-12 buttonstyle mt-1" mat-raised-button [disabled]="!resetPasswordForm.form.valid">Submit</button>
                    <button class="col-md-12 buttonstyle mt-2" mat-raised-button (click)="Navigate()">Cancel</button>
                  </div>
              
                </form>
                
                
              </div>
  
            </div>
            <div class="col-4  mt-5 pl-5 pt-5" >
              <!-- <img src="/assets/images/SI4.png" class="imgstyle pl-2" alt="HS logo"> -->
              <img src="/assets/images/image.png" alt="" class="imgstyle pl-2">
          </div>
          </div>
            
        </div>
    </mat-drawer-content>
  
    <mat-drawer-content>
        <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
